import * as moderation from './api/moderation'
import * as blogs from './api/blogs'
import * as caseStudies from './api/case-studies'

export default {
 moderation,
 blogs,
 caseStudies
};